/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTermsRouteImport } from './routes/_authenticated/terms'
import { Route as AuthenticatedLobbyRouteImport } from './routes/_authenticated/lobby'
import { Route as AuthenticatedHowToPlayRouteImport } from './routes/_authenticated/how-to-play'
import { Route as AuthenticatedContestContestIdRouteImport } from './routes/_authenticated/contest.$contestId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTermsRoute = AuthenticatedTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLobbyRoute = AuthenticatedLobbyRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHowToPlayRoute = AuthenticatedHowToPlayRouteImport.update({
  id: '/how-to-play',
  path: '/how-to-play',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContestContestIdRoute =
  AuthenticatedContestContestIdRouteImport.update({
    id: '/contest/$contestId',
    path: '/contest/$contestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/how-to-play': typeof AuthenticatedHowToPlayRoute
  '/lobby': typeof AuthenticatedLobbyRoute
  '/terms': typeof AuthenticatedTermsRoute
  '/contest/$contestId': typeof AuthenticatedContestContestIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/how-to-play': typeof AuthenticatedHowToPlayRoute
  '/lobby': typeof AuthenticatedLobbyRoute
  '/terms': typeof AuthenticatedTermsRoute
  '/contest/$contestId': typeof AuthenticatedContestContestIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/how-to-play': typeof AuthenticatedHowToPlayRoute
  '/_authenticated/lobby': typeof AuthenticatedLobbyRoute
  '/_authenticated/terms': typeof AuthenticatedTermsRoute
  '/_authenticated/contest/$contestId': typeof AuthenticatedContestContestIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/how-to-play' | '/lobby' | '/terms' | '/contest/$contestId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/how-to-play' | '/lobby' | '/terms' | '/contest/$contestId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/how-to-play'
    | '/_authenticated/lobby'
    | '/_authenticated/terms'
    | '/_authenticated/contest/$contestId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/terms': {
      id: '/_authenticated/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AuthenticatedTermsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lobby': {
      id: '/_authenticated/lobby'
      path: '/lobby'
      fullPath: '/lobby'
      preLoaderRoute: typeof AuthenticatedLobbyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/how-to-play': {
      id: '/_authenticated/how-to-play'
      path: '/how-to-play'
      fullPath: '/how-to-play'
      preLoaderRoute: typeof AuthenticatedHowToPlayRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contest/$contestId': {
      id: '/_authenticated/contest/$contestId'
      path: '/contest/$contestId'
      fullPath: '/contest/$contestId'
      preLoaderRoute: typeof AuthenticatedContestContestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedHowToPlayRoute: typeof AuthenticatedHowToPlayRoute
  AuthenticatedLobbyRoute: typeof AuthenticatedLobbyRoute
  AuthenticatedTermsRoute: typeof AuthenticatedTermsRoute
  AuthenticatedContestContestIdRoute: typeof AuthenticatedContestContestIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHowToPlayRoute: AuthenticatedHowToPlayRoute,
  AuthenticatedLobbyRoute: AuthenticatedLobbyRoute,
  AuthenticatedTermsRoute: AuthenticatedTermsRoute,
  AuthenticatedContestContestIdRoute: AuthenticatedContestContestIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
